// extracted by mini-css-extract-plugin
export default {"sideNav":"Obtmgmt_sideNav__qwlm1","obtMgmtBody":"Obtmgmt_obtMgmtBody__mI+jl","grid":"Obtmgmt_grid__D09kw","container":"Obtmgmt_container__SzTQ3","content":"Obtmgmt_content__4VyBd"};